module.exports = __webpack_public_path__ + "7978889a8b8741d9a0163533f19c2e5d.svg";